// src/pages/wartungsprotokoll/WartungsprotokollSeite8.jsx

import React, { useState } from "react";
import { Box } from "@chakra-ui/react";
import { Button } from "@chakra-ui/react";


export default function WartungsprotokollSeite8({ form, setForm }) {

    const [showZusatz1, setShowZusatz1] = useState(false);
    const [showZusatz2, setShowZusatz2] = useState(false);

  if (
    !form ||
    !form.pruefungAussen ||
    !form.zusatzAussen ||
    !form.pruefungDiebstahl ||
    !form.zusatzDiebstahl
  ) return null;

  // helper to update checkbox groups
  const updateRow = (section, index, field) => {
    setForm(prev => {
      const updated = [...prev[section]];
      updated[index][field] = !updated[index][field];
      return { ...prev, [section]: updated };
    });
  };

  // helper for zusatz tables
  const updateZusatz = (table, index, field, value) => {
    setForm(prev => {
      const updated = [...prev[table]];
      updated[index][field] = value;
      return { ...prev, [table]: updated };
    });
  };

  return (
    
    <div className="p-6 text-sm">
      <Box p={8} bg="white" borderRadius="xl" boxShadow="md" mt={3} mb={3}>
      {/* ====================================================== */}
      {/*                   SECTION 11                          */}
      {/* ====================================================== */}

      <h2 style={{ fontWeight: "bold" }}>
        11 Prüfung Zaunanlage, Gelände, Straßen und Gebäude
      </h2>

      <table className="w-full mb-6 text-xs" style={{ borderCollapse: "collapse" }}>
         <thead>
          <tr className="border-b font-semibold text-center">
            <th className="p-2 w-2/3 text-left"></th>
            <th className="p-2 min-w-[90px]">ja</th>
            <th className="p-2 min-w-[90px]">nein</th>
            <th className="p-2 min-w-[90px]">nicht zutreffend</th>
          </tr>
        </thead>
        <tbody>
          {[
            "11.1 Die Zaunanlage ist frei von Schäden",
            "11.2 Tore und Schließmechanismus sind in Ordnung",
            "11.3 Das Gelände befindet sich in gutem Zustand",
            "11.4 Die Straßen im Gelände befinden sich in gutem Zustand",
            "11.5 Die Zufahrten befinden sich in gutem Zustand, sind frei und zugänglich",
            "11.6 Der Bewuchs der Anlage ist in Ordnung, auch bei WR, Verteiler, Gebäude",
            "11.7 Die Anlageng ebäude befinden sich in gutem Zustand",
            "11.8 Das Dach / die Eindeckung befindet sich in gutem Zustand",
            "11.9 Die Anlagenbeleuchtung befindet sich in gutem Zustand"
          ].map((text, idx) => (
            <tr key={idx}>
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "70%" }}>
                {text}
              </td>

              {/* Ja */}
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
                
                <input
                  type="checkbox"
                  checked={form.pruefungAussen?.[idx]?.ja || false}
                  onChange={() =>
                    setForm(f => {
                      const list = [...(f.pruefungAussen || [])];
                      list[idx] = { ja: true, nein: false, nz: false };
                      return { ...f, pruefungAussen: list };
                    })
                  }
                />
              </td>

              {/* Nein */}
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
                
                <input
                  type="checkbox"
                  checked={form.pruefungAussen?.[idx]?.nein || false}
                  onChange={() =>
                    setForm(f => {
                      const list = [...(f.pruefungAussen || [])];
                      list[idx] = { ja: false, nein: true, nz: false };
                      return { ...f, pruefungAussen: list };
                    })
                  }
                />
              </td>

              {/* Nicht zutreffend */}
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
                
                <input
                  type="checkbox"
                  checked={form.pruefungAussen?.[idx]?.nz || false}
                  onChange={() =>
                    setForm(f => {
                      const list = [...(f.pruefungAussen || [])];
                      list[idx] = { ja: false, nein: false, nz: true };
                      return { ...f, pruefungAussen: list };
                    })
                  }
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <Box mb={3} mt={4}>
            
                    <Button
                      onClick={() => setShowZusatz1(!showZusatz1)}
                      colorScheme="blue"
                      borderRadius="lg"
                    >
                      {showZusatz1 ? "Zusatz-Tabelle minimieren" : "Zusatz-Tabelle anzeigen"}
                    </Button>
            
               </Box>


      {/* ==================== ZUSATZ-TABELLE #1 ==================== */}
       {showZusatz1 && (
        <>

      <h3 className="font-semibold mb-2 mt-4">Zusatz-Tabelle</h3>

      <table className="w-full mb-6 text-xs" style={{ borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "15%" }}>
              Zu Punkt
            </th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "45%" }}>
              Bemerkungen / Mängel
            </th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "15%" }}>
              Standort Mangel
            </th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "5%" }}>
              Plan
            </th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "10%" }}>
              Bild-Nr.
            </th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "5%" }}>
              Beh.
            </th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "5%" }}>
              n. Beh.
            </th>
          </tr>
        </thead>

        <tbody>
          {form.zusatzAussen.map((row, idx) => (
            <tr key={idx}>

              {/* text inputs */}
              {["zupunkt", "bemerkung", "standort"].map(field => (
                <td key={field} style={{ border: "1px solid #ccc", padding: "3px" }}>
                  <input
                    type="text"
                    value={row[field]}
                    onChange={e => updateZusatz("zusatzAussen", idx, field, e.target.value)}
                    style={{
                      width: "100%",
                      border: "none",
                      backgroundColor: "#f7f7fb",
                      height: "18px"
                    }}
                  />
                </td>
              ))}

              {/* plan checkbox */}
              <td style={{ border: "1px solid #ccc", padding: "3px", textAlign: "center" }}>
                <input
                  type="checkbox"
                  checked={row.plan}
                  onChange={() => updateZusatz("zusatzAussen", idx, "plan", !row.plan)}
                />
              </td>

              {/* Bildnr */}
              <td style={{ border: "1px solid #ccc", padding: "3px" }}>
                <input
                  type="text"
                  value={row.bildnr}
                  onChange={e => updateZusatz("zusatzAussen", idx, "bildnr", e.target.value)}
                  style={{
                    width: "100%",
                    border: "none",
                    backgroundColor: "#f7f7fb",
                    height: "18px"
                  }}
                />
              </td>

              {/* beh + nbeh */}
              {["beh", "nbeh"].map(field => (
                <td key={field}
                  style={{ border: "1px solid #ccc", padding: "3px", textAlign: "center" }}
                >
                  <input
                    type="checkbox"
                    checked={row[field]}
                    onChange={() => updateZusatz("zusatzAussen", idx, field, !row[field])}
                  />
                </td>
              ))}

            </tr>
          ))}
        </tbody>
      </table>

          </>
       )}

      </Box>

      {/* ====================================================== */}
      {/*                   SECTION 12                          */}
      {/* ====================================================== */}

      <Box p={8} bg="white" borderRadius="xl" boxShadow="md" mt={3} mb={3}>
      <h2 style={{ fontWeight: "bold" }}>
        12 Prüfung Diebstahlschutz (einfache Sichtprüfung)
      </h2>

      <table className="w-full mb-6 text-xs" style={{ borderCollapse: "collapse" }}>
          <thead>
          <tr className="border-b font-semibold text-center">
            <th className="p-2 w-2/3 text-left"></th>
            <th className="p-2 min-w-[90px]">ja</th>
            <th className="p-2 min-w-[90px]">nein</th>
            <th className="p-2 min-w-[90px]">nicht zutreffend</th>
          </tr>
        </thead>
        <tbody>
          {[
            "12.1 Die Videokameras sind frei von Schäden",
            "12.2 Die Videokameras sind richtig ausgerichtet und werden nicht bedeckt",
            "12.3 Die Datenübertragung wurde bestätigt",
            "12.4 Die Alarmanlage ist funktionsfähig (Zu- und Abschaltung)",
            "12.5 Die Sensoren sind frei von Beschädigungen und funktionsfähig"
          ].map((text, idx) => (
            <tr key={idx}>
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "70%" }}>
                {text}
              </td>

              {/* Ja */}
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
         
                <input
                  type="checkbox"
                  checked={form.pruefungDiebstahl?.[idx]?.ja || false}
                  onChange={() =>
                    setForm(f => {
                      const list = [...(f.pruefungDiebstahl || [])];
                      list[idx] = { ja: true, nein: false, nz: false };
                      return { ...f, pruefungDiebstahl: list };
                    })
                  }
                />
              </td>

              {/* Nein */}
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
              
                <input
                  type="checkbox"
                  checked={form.pruefungDiebstahl?.[idx]?.nein || false}
                  onChange={() =>
                    setForm(f => {
                      const list = [...(f.pruefungDiebstahl || [])];
                      list[idx] = { ja: false, nein: true, nz: false };
                      return { ...f, pruefungDiebstahl: list };
                    })
                  }
                />
              </td>

              {/* n.z. */}
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
              
                <input
                  type="checkbox"
                  checked={form.pruefungDiebstahl?.[idx]?.nz || false}
                  onChange={() =>
                    setForm(f => {
                      const list = [...(f.pruefungDiebstahl || [])];
                      list[idx] = { ja: false, nein: false, nz: true };
                      return { ...f, pruefungDiebstahl: list };
                    })
                  }
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>


         <Box mb={3} mt={4}>
            
           <Button
                 onClick={() => setShowZusatz2(!showZusatz2)}
                   colorScheme="blue"
                 borderRadius="lg"
              >
                {showZusatz2 ? "Zusatz-Tabelle minimieren" : "Zusatz-Tabelle anzeigen"}
             </Button>
            
           </Box>


      {/* ==================== ZUSATZ-TABELLE #2 ==================== */}

       {showZusatz2 && (
        <>

      <h3 className="font-semibold mb-2 mt-4">Zusatz-Tabelle</h3>

      <table className="w-full mb-6 text-xs" style={{ borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "15%" }}>Zu Punkt</th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "45%" }}>Bemerkungen / Mängel</th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "15%" }}>Standort Mangel</th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "5%" }}>Plan</th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "10%" }}>Bild-Nr.</th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "5%" }}>Beh.</th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "5%" }}>n. Beh.</th>
          </tr>
        </thead>

        <tbody>
          {form.zusatzDiebstahl.map((row, idx) => (
            <tr key={idx}>

              {["zupunkt", "bemerkung", "standort"].map(field => (
                <td key={field} style={{ border: "1px solid #ccc", padding: "3px" }}>
                  <input
                    type="text"
                    value={row[field]}
                    onChange={e => updateZusatz("zusatzDiebstahl", idx, field, e.target.value)}
                    style={{
                      width: "100%",
                      border: "none",
                      backgroundColor: "#f7f7fb",
                      height: "18px"
                    }}
                  />
                </td>
              ))}

              <td style={{ border: "1px solid #ccc", padding: "3px", textAlign: "center" }}>
                <input
                  type="checkbox"
                  checked={row.plan}
                  onChange={() => updateZusatz("zusatzDiebstahl", idx, "plan", !row.plan)}
                />
              </td>

              <td style={{ border: "1px solid #ccc", padding: "3px" }}>
                <input
                  type="text"
                  value={row.bildnr}
                  onChange={e => updateZusatz("zusatzDiebstahl", idx, "bildnr", e.target.value)}
                  style={{
                    width: "100%",
                    border: "none",
                    backgroundColor: "#f7f7fb",
                    height: "18px"
                  }}
                />
              </td>

              {["beh", "nbeh"].map(field => (
                <td key={field} style={{ border: "1px solid #ccc", padding: "3px", textAlign: "center" }}>
                  <input
                    type="checkbox"
                    checked={row[field]}
                    onChange={() => updateZusatz("zusatzDiebstahl", idx, field, !row[field])}
                  />
                </td>
              ))}

            </tr>
          ))}
        </tbody>
      </table>
         </>
       )}
      </Box>
    </div>
  );
}